import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    id: "application",
    question: "How should the spray be applied?",
    answer:
      "Shake well before use to blend the botanical oils and aloe gel. Mist onto pulse points and collarbones for all-day hydration and subtle attraction.",
  },
  {
    id: "shipping",
    question: "What are the shipping destinations?",
    answer:
      "We ship directly from Canada to select international destinations with express tracking provided at Stripe checkout.",
  },
  {
    id: "sensitive-skin",
    question: "Is this formula gentle on sensitive skin?",
    answer:
      "Yes. Built with witchhazel, aloe gel, hemp oil, and distilled water, it moisturizes without parabens or harsh solvents.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 px-6 max-w-4xl mx-auto border-b border-[var(--line)]"
    >
      <div className="text-center mb-12">
        <span className="label-caps text-[11px] text-[var(--ink)]/70">Inquiries</span>
        <h2 className="serif-head text-3xl sm:text-4xl text-[var(--ink)] mt-2">
          Product Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((faq) => (
          <AccordionItem
            key={faq.id}
            value={faq.id}
            data-testid={`faq-item-${faq.id}`}
            className="border border-[var(--line)] px-6 bg-[var(--card-bg)]"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${faq.id}`}
              className="serif-head text-lg text-[var(--ink)] hover:no-underline py-5 text-left"
            >
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-xs text-[var(--ink)]/75 font-light leading-relaxed pb-5">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
